import backgroundL from "../images/bg-intro-desktop.svg";
import backgroundM from "../images/bg-intro-mobile.svg";
import phones from "../images/image-mockups.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Grid } from "@mui/material";
const Banking = () => {
  const matches = useMediaQuery("(min-width:480px)");
  const style = {
    padding: "10rem 0 5rem 10rem ",
    marginTop: "3rem",
    backgroundColor: "hsl(0, 0%, 98%)",
    position: "relative",
    height: "58vh",
  };
  const styleM = {
    padding: "10rem 1.1rem 5rem ",
    marginTop: "3rem",
    backgroundColor: "hsl(0, 0%, 98%)",
    position: "relative",
    height: "58vh",
    textAlign: "center",
  };
  const introStyle = {
    width: "28rem",
    marginTop: "3rem",
  };
  const introStyleM = {
    marginTop: "10rem",
  };

  const phonesL = {
    position: "absolute",
    left: "60.2rem",
    top: "-3.5rem",
    zIndex: 1,
  };
  const phonesM = {
    position: "absolute",
    width: "22rem",
    top: "-8.3rem",
    left: "1rem",
  };
  const Background = () => {
    const styleL = {
      position: "absolute",
      top: "-11rem",
      width: "75rem",
      left: "45rem",
    };
    const styleM = {
      position: "absolute",
      top: "-7rem",
      right: 0,
    };

    if (!matches) {
      return <img src={backgroundM} style={styleM} className="background" />;
    } else {
      return <img src={backgroundL} style={styleL} className="background" />;
    }
  };

  return (
    <div style={matches ? style : styleM}>
      <Grid>
        <div style={matches ? introStyle : introStyleM}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <h1>Next generation digital banking</h1>
            <p>
              {" "}
              Take your financial life online. Your Easybank account will be a
              one-stop-shop for spending, saving, budgeting, investing, and much
              more.
            </p>
          </Grid>
          <button
            style={matches ? { marginTop: "1rem" } : { marginTop: "2rem" }}
          >
            Request Invite
          </button>
        </div>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Background />
          <img src={phones} style={matches ? phonesL : phonesM} />
        </Grid>
      </Grid>
    </div>
  );
};

export default Banking;
